import { Entity } from '@jms/model';

export interface AssettNMCMessageOutbound {
    _id: string;
    correlationId: string;
    eventId: string;
    lockId: string;
    endpoint: HomesNSWOutboundEndpoint;
    eventDateTime: string;
    eventDateTimeUTC: Date;
    createdAt: Date;
    updatedAt: Date;
    status: NMCMessageStatus;
    statusMessage: string;
    data: any;
    fileContent?: HomesNSWFileContent;
    reprocessedBy?: Entity;
    reprocessedDate?: Date;
}

export enum NMCMessageStatus {
    New = 'new',
    Acknowledged = 'acknowledged',
    FileContentReady = 'fileContentReady',
    Processing = 'processing',
    Processed = 'processed',
    Failed = 'failed'
}

export interface AssettNMCProcessResult {
    success: boolean;
    message: string;
}

export interface AssettNMCMessageInbound {
    _id: string;
    sourceEvent: string;
    createdAt: Date;
    updatedAt: Date;
    status: NMCMessageStatus;
    data: any;
}

export enum HomesNSWOutboundEndpoint {
    WorkOrders = 'workorders',
    PriorityWorkOrders = 'priority-workorders',
    WorkOrderUpdates = 'workorder-updates',
    SupplementaryWorks = 'supplementaryworks',
    EOTResponses = 'eot-responses',
    ServiceAppointments = 'service-appointments',
    Remittances = 'remittances',
    PaymentStatuses = 'payment-statuses',
    ClaimStatuses = 'claim-statuses',

    Notices = 'notices',
    NoticeUpdates = 'notice-updates',
    Escalations = 'escalations',
    CreditNotes = 'creditnotes',
    Comments = 'comments',

    Files = 'files',
    FileContents = 'file',

    Acknowledgements = 'acknowledgement',
}

export interface HomesNSWFileContent {
    file: HomesNSWFileContentDetails;
    //Added this ourselves to help with processing
    path?: string;
}

export interface HomesNSWFileContentDetails {
    content: string;
    title: string;
    filetype: string;
}

export enum HomesNSWOutboundMessageEntityFormAction {
    ReprocessMessage = 'ReprocessMessageCommand',
}
export type HomesNSWOutboundMessageEntityCommandRequest =
    {
        commandId: 'ReprocessMessageCommand',
        data: {
            outboundMessage: AssettNMCMessageOutbound
        }
    }